var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('transition-group',{staticClass:"labs",attrs:{"tag":"div"}},_vm._l((_vm.labs),function(lab){return _c('div',{key:lab.id},[_c('lab-component',{attrs:{"lab":lab}})],1)}),0)],1)}
var staticRenderFns = []

export { render, staticRenderFns }